import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { GetPaidForms } from '@app/+payment/models/forms.enum';

@Component({
  selector: 'vc-success-popin',
  templateUrl: './success-popin.component.html',
  styleUrls: ['./success-popin.component.scss']
})
export class SuccessPopinComponent implements OnInit {
  formEnum = GetPaidForms;

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: { form: GetPaidForms },
    public dialogRef: MatDialogRef<SuccessPopinComponent>
  ) {}

  ngOnInit() {
    setTimeout(() => this.dialogRef.close(), 5000);
  }
}
